import { gql } from 'graphql-tag'
import { userFragment } from '../admin/users/usersQueries'

export const fetchMe = gql`
  query FetchMe {
    me {
      ...UserFragment
      stations {
        id
        name
      }
      permissions
    }
  }
  ${userFragment}
`
